export const SET = '/mileage-package/set';
